import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { SessionService } from "./session.service";
import { DangerError } from "@shared/errors/custom.error";

@Injectable({ providedIn: "root" })
export class SancionService {
    private readonly rutSinDV: number;

    constructor(
        private apiService: ApiService,
        private sessionService: SessionService
    ) {
        this.rutSinDV = this.sessionService.getSesionActual().getRutSinDV();
    }

    async ejecutarSancion(
        p_expediente: number,
        p_licencias: number,
        p_prestador: number,
        p_pasada: number,
    ) {
        const { ok, resultado_calculo, tiene_sancion, bloqueo_disparado, bloqueo_payload, info_bloqueo } =
            await this.apiService.privatePost<any>(
                "sancion",
                { p_expediente, p_licencias, p_prestador, p_pasada }
            );

        const { success, msg } = resultado_calculo || {};

        if (!ok || success !== "true") throw new DangerError(msg || "Error al ejecutar sanción");

        return { msg, resultado_calculo, tiene_sancion, bloqueo_disparado, bloqueo_payload, info_bloqueo };
    }
}
